/* global React, Button, t */
function YearClosingBackButton({ context = {}, setRoute, onComplete, label, fallbackRoute = 'arsavslutning', currentRoute = '', hideWhenEmbedded = true } = {}) {
  if (hideWhenEmbedded && context.embedded) return null;
  const defaultLabel = context.returnRoute === 'aiautopilot'
    ? t('clo.backToAiBookkeeper', 'Tilbake til AI Regnskapsfører')
    : t('clo.backToYearClosing', 'Tilbake til årsavslutning');
  const goBack = () => {
    if (context.onBack) { context.onBack(); return; }
    if (onComplete) { onComplete(); return; }
    if (context.returnSurface) window.__plummeReturnSurface = context.returnSurface;
    const requestedRoute = context.returnRoute || fallbackRoute;
    const route = requestedRoute === currentRoute ? fallbackRoute : requestedRoute;
    if (setRoute) setRoute(route);
    else window.plummeNav?.(route);
  };
  return <Button variant="secondary" icon="arrowLeft" onClick={goBack}>{label || defaultLabel}</Button>;
}

function YearClosingBankBackButton({ workAreaContext, setRoute } = {}) {
  const [standaloneContext] = React.useState(() => {
    if (workAreaContext?.embedded) return null;
    const context = window.__plummeNextWorkAreaContext || null;
    window.__plummeNextWorkAreaContext = null;
    return context;
  });
  const context = workAreaContext || standaloneContext || {};
  if (context.source !== 'year-end' || context.checkId !== 'bank') return null;
  return <YearClosingBackButton context={context} setRoute={setRoute} currentRoute="bank"/>;
}

function YearClosingActions({ target, children }) {
  const actions = <div className="row wrap gap-12 cl-work-area-actions">{children}</div>;
  return target ? window.ReactDOM.createPortal(actions, target) : actions;
}

Object.assign(window, { YearClosingBackButton, YearClosingBankBackButton, YearClosingActions });
